
import React, {FC} from 'react';
import Arrow from 'templates/reports/_shared/Arrow';
import {Summary} from 'templates/reports/query';

import {Column, columns} from './configs';

import * as styles from './styles.module.scss';

type RowProps = {
	curr: Summary
	prev: Summary | null
}

const Row: FC<RowProps> = ({curr, prev}) => {
	const content = (c: Column) => {
		if (c.arrow && c.fmt && c.val) {
			const props = {
				curr: {
					value: c.val(curr),
				},
				prev: prev ? {
					value: c.val(prev),
				} : null,
				color: c.arrow,
			};

			return (
				<div className={styles.arrow}>
					<Arrow {...props} />
					<span>{c.fmt(c.val(curr))}</span>
				</div>
			);
		}

		if (c.fmt && c.val) {
			return c.fmt(c.val(curr));
		}

		return c.str ? c.str(curr) : '';
	};

	return (
		<tr>
			{columns.map((c, i) => (
				<td key={i}>
					{content(c)}
				</td>
			))}
		</tr>
	);
};

export default Row;
